import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  SEARCH_COURSES_LIST_GET,
  SEARCH_DOCUMENTS_LIST_GET,
  SEARCH_DOCUMENTS_EXPERT_LIST_GET,
  SEARCH_MODULES_LIST_GET,
  SEARCH_WORD_SET,
  SEARCH_EVENTS_LIST_GET,
} from '../actions/search';

const initialState = {
  search_word: '',
  courses: {
    filters: {},
    list: [],
    pager: {},
  },
  modules: {
    filters: {},
    list: [],
    pager: {},
  },
  events: {
    filters: {},
    list: [],
    pager: {},
  },
  documents: {
    filters: {},
    list: [],
    pager: {},
  },
  documentsExpert: {
    filters: {},
    list: [],
    pager: {},
  },
};

const searchReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case SEARCH_WORD_SET:
        draft.search_word = action.response;
        break;

      case SEARCH_COURSES_LIST_GET._SUCCESS: {
        const { data, pager } = action;
        draft.courses.filters = {
          ...state.courses.filters,
          ...(data?.filters || {}),
        };
        draft.courses.list = data?.items || [];
        draft.courses.pager = pager;
        break;
      }

      case SEARCH_MODULES_LIST_GET._SUCCESS: {
        const { data, pager } = action;
        draft.modules.filters = {
          ...state.modules.filters,
          ...(data?.filters || {}),
        };
        draft.modules.list = data?.items || [];
        draft.modules.pager = pager;
        break;
      }

      case SEARCH_EVENTS_LIST_GET._SUCCESS: {
        const { data, pager } = action;
        draft.events.filters = {
          ...state.events.filters,
          ...(data?.filters || {}),
        };
        draft.events.list = data?.items || [];
        draft.events.pager = pager;
        break;
      }

      case SEARCH_DOCUMENTS_LIST_GET._SUCCESS: {
        const { data, pager } = action;
        draft.documents.filters = {
          ...state.documents.filters,
          ...(data?.filters || {}),
        };
        draft.documents.list = data?.items || [];
        draft.documents.pager = pager;
        break;
      }

      case SEARCH_DOCUMENTS_EXPERT_LIST_GET._SUCCESS: {
        const { data, pager } = action;
        draft.documentsExpert.filters = {
          ...state.documentsExpert.filters,
          ...(data?.filters || {}),
        };
        draft.documentsExpert.list = data?.items || [];
        draft.documentsExpert.pager = pager;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default searchReducer;
